import FeeIcon from '../media/fee.png';
import ClickIcon from '../media/click.png';
import BudgetIcon from '../media/budget.png';
import ControlIcon from '../media/control.png';

export const CheckItems = [{
  key: 'fee',
  text: _TL_('No minimum fee'),
  imgSrc: FeeIcon,
}, {
  key: 'click',
  text: _TL_('Only pay for clicks'),
  imgSrc: ClickIcon,
}, {
  key: 'budget',
  text: _TL_('Budget by the day'),
  imgSrc: BudgetIcon,
}, {
  key: 'control',
  text: _TL_('Control your own budget'),
  imgSrc: ControlIcon,
}];
